import React, { memo, useCallback, type RefObject } from 'react';
import { MeatballMenu } from '@atlassian/jira-software-context-menu/src/ui/MeatballMenu.tsx';
import { AsyncMenuRenderer } from '@atlassian/jira-software-context-menu/src/async.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { useMoveTo } from './menu-items/move-to/index.tsx';
import messages from './messages.tsx';

interface ContextMenuProps {
	cardId: number;
	onOpenChange?: (isOpen: boolean) => void;
	triggerRef?: RefObject<HTMLButtonElement>;
	setAnnouncement: (message: string) => void;
}

export const ContextMenu = memo((props: ContextMenuProps) => {
	const { cardId, onOpenChange, triggerRef, setAnnouncement } = props;
	const { formatMessage } = useIntl();

	const moveToMenuItems = useMoveTo({ cardId, setAnnouncement });

	const renderMenu = useCallback(
		(scope: string, menuTriggerRef?: RefObject<HTMLButtonElement>) => {
			if (!moveToMenuItems) {
				return null;
			}
			return (
				<AsyncMenuRenderer
					scope={scope}
					menuItems={moveToMenuItems}
					triggerRef={menuTriggerRef || triggerRef}
				/>
			);
		},
		[moveToMenuItems, triggerRef],
	);

	if (!moveToMenuItems) {
		return null;
	}

	return (
		<MeatballMenu
			scope={`${cardId}`}
			renderMenu={renderMenu}
			cardId={cardId}
			selectedCardIds={[cardId]}
			ariaLabel={formatMessage(messages.moreActions)}
			onOpenChange={onOpenChange}
			jsErrorBoundaryProps={{
				id: 'epic-card-menu',
				packageName: 'backlog',
				teamName: 'a4t-pandora',
			}}
		/>
	);
});
